import { Capacitor } from "@capacitor/core";
import { publish } from "@ionic/portals";

/**
 * The "openLinkExternally" Portals topic is only consumed by the native shell — on the
 * web platform it has no subscriber and silently no-ops, so open a new tab instead.
 */
export async function openExternalLink(url: string): Promise<void> {
  if (Capacitor.getPlatform() === "web") {
    window.open(url, "_blank", "noopener");
    return;
  }
  await publish({ topic: "openLinkExternally", data: { url } });
}
